import {Suspense, useState} from "react";
import {Modal} from "react-bootstrap";
import {FiArrowLeft} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {ServiceGroup, ServiceTag} from "@/lib/types/checks.ts";
import {DashboardDefinition} from "@/lib/types/website.ts";
import {DashboardForm} from "@/pages/dashboard/edit/DashboardForm.tsx";

interface EditDashboardModalProps {
  dashboardDef: DashboardDefinition;
  dashboardDefs: DashboardDefinition[];
  tags: ServiceTag[];
  monitoringServiceTypes: ServiceGroup[];
  show: boolean;
  close: () => void;
  cancel: () => void;
  updateDashboardDef: (dashboardDef: DashboardDefinition) => void;
}

const formId = "dashboard-form";

export const EditDashboardModal = ({
  dashboardDef,
  dashboardDefs,
  tags,
  monitoringServiceTypes,
  show,
  close,
  cancel,
  updateDashboardDef,
}: EditDashboardModalProps) => {
  const [showCheckPicker, setShowCheckPicker] = useState(false);

  const checkPickerFooter = (
    <Modal.Footer className="justify-content-start">
      <Button variant="secondary" onClick={() => setShowCheckPicker(false)}>
        <Icon icon={FiArrowLeft} className="me-2" />
        Back to Content
      </Button>
    </Modal.Footer>
  );

  return (
    <Suspense>
      <UpErrorBoundary>
        <FormModal
          title="Customize Dashboard"
          onCancel={cancel}
          show={show}
          size="lg"
          formId={formId}
          submitBtnText="Preview"
          footer={showCheckPicker ? checkPickerFooter : undefined}
        >
          <DashboardForm
            formId={formId}
            dashboardDef={dashboardDef}
            dashboardDefs={dashboardDefs}
            tags={tags}
            monitoringServiceTypes={monitoringServiceTypes}
            updateDashboardDef={updateDashboardDef}
            hide={close}
            showCheckPicker={showCheckPicker}
            onShowCheckPickerChange={setShowCheckPicker}
          />
        </FormModal>
      </UpErrorBoundary>
    </Suspense>
  );
};
